
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const Contact = () => {
  return (
    <Layout>
      <section className="py-20 bg-gradient-to-br from-juv-cream-white to-white">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-4xl mx-auto mb-16">
            <h1 className="text-4xl md:text-6xl font-bold text-juv-deep-chestnut mb-6 font-juv-display">
              Contact Us
            </h1>
            <p className="text-xl text-juv-deep-chestnut/70 leading-relaxed">
              Ready to start your glow journey? We're here to help with any questions about treatments, memberships, or booking.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Contact Form */}
            <Card className="bg-white shadow-luxury border-juv-rose-clay/20">
              <CardHeader>
                <CardTitle className="text-2xl font-bold text-juv-deep-chestnut font-juv-display">
                  Send Us a Message
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-juv-deep-chestnut mb-2">
                      First Name
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 border border-juv-rose-clay/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-juv-terracotta"
                      placeholder="Your first name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-juv-deep-chestnut mb-2">
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 border border-juv-rose-clay/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-juv-terracotta"
                      placeholder="Your last name"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-juv-deep-chestnut mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    className="w-full px-4 py-3 border border-juv-rose-clay/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-juv-terracotta"
                    placeholder="your.email@example.com"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-juv-deep-chestnut mb-2">
                    Phone
                  </label>
                  <input
                    type="tel"
                    className="w-full px-4 py-3 border border-juv-rose-clay/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-juv-terracotta"
                    placeholder="(555) 123-4567"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-juv-deep-chestnut mb-2">
                    Message
                  </label>
                  <textarea
                    rows={4}
                    className="w-full px-4 py-3 border border-juv-rose-clay/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-juv-terracotta"
                    placeholder="Tell us about your goals and any questions you have..."
                  />
                </div>
                
                <Button className="w-full bg-juv-gradient-primary text-white hover:shadow-luxury">
                  Send Message
                </Button>
              </CardContent>
            </Card>

            {/* Contact Information */}
            <div className="space-y-8">
              <Card className="bg-gradient-to-br from-white to-juv-soft-blush/30 border-juv-rose-clay/20">
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="w-12 h-12 bg-juv-gradient-primary rounded-full flex items-center justify-center">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-juv-deep-chestnut font-juv-heading">Location</h3>
                      <p className="text-juv-deep-chestnut/70">123 Glow Street<br />Beverly Hills, CA 90210</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-white to-juv-soft-blush/30 border-juv-rose-clay/20">
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="w-12 h-12 bg-juv-gradient-primary rounded-full flex items-center justify-center">
                      <Phone className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-juv-deep-chestnut font-juv-heading">Phone</h3>
                      <p className="text-juv-deep-chestnut/70">(555) JUV-GLOW<br />(555) 588-4569</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-white to-juv-soft-blush/30 border-juv-rose-clay/20">
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="w-12 h-12 bg-juv-gradient-primary rounded-full flex items-center justify-center">
                      <Mail className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-juv-deep-chestnut font-juv-heading">Email</h3>
                      <p className="text-juv-deep-chestnut/70">hello@juv.com<br />support@juv.com</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-white to-juv-soft-blush/30 border-juv-rose-clay/20">
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="w-12 h-12 bg-juv-gradient-primary rounded-full flex items-center justify-center">
                      <Clock className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-juv-deep-chestnut font-juv-heading">Hours</h3>
                      <p className="text-juv-deep-chestnut/70">Mon-Fri: 9am-7pm<br />Sat-Sun: 10am-6pm</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
